import { render, staticRenderFns } from "./EditJob.vue?vue&type=template&id=bb54d12c&scoped=true&"
import script from "./EditJob.vue?vue&type=script&lang=js&"
export * from "./EditJob.vue?vue&type=script&lang=js&"
import style0 from "./EditJob.vue?vue&type=style&index=0&id=bb54d12c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb54d12c",
  null
  
)

export default component.exports